export default "__VITE_ASSET__DWsf5T3___"